import { render, staticRenderFns } from "./MainBreadcrumb.vue?vue&type=template&id=888e875a&scoped=true&"
import script from "./MainBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./MainBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./MainBreadcrumb.vue?vue&type=style&index=0&id=888e875a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888e875a",
  null
  
)

export default component.exports